var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-input",on:{"click":_vm.clickEvent}},[_c('image-base',{staticClass:"button-input__icon",attrs:{"src":_vm.iconPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }